import React, { FC, useState } from 'react';
import styles from '../journey-explorer.module.scss';
import { MapMode } from '../journey-explorer-utils';

export interface MapKeyColour {
	label: string;
	color: string;
}

const MODE_TEXT: Record<MapMode, string> = {
	customers: 'customers',
	median: 'median time to the next step, the typical customer',
	time: 'average time to the next step',
};

interface MapKeyProps {
	mode: MapMode;
	goalLabel: string | null;
	overallGoalPct: number | null;
	colours: MapKeyColour[];
}

const MapKey: FC<MapKeyProps> = ({ mode, goalLabel, overallGoalPct, colours }) => {
	const [open, setOpen] = useState(false);

	return (
		<div className={styles.map_key} onMouseDown={(event) => event.stopPropagation()}>
			<span
				className={styles.map_key_icon}
				tabIndex={0}
				aria-label="How to read the map"
				onMouseEnter={() => setOpen(true)}
				onMouseLeave={() => setOpen(false)}
				onFocus={() => setOpen(true)}
				onBlur={() => setOpen(false)}
			>
				i
				{open && (
					<span role="tooltip" className={styles.map_tooltip}>
						Border and line thickness: {MODE_TEXT[mode]}.
						{goalLabel && (
							<>
								<br />
								<span className={styles.map_tooltip_goal}>Green %</span>: share who reached {goalLabel}
								{overallGoalPct === null ? '.' : `, overall ${overallGoalPct.toFixed(1)}%.`}
							</>
						)}
						{colours.length > 1 && (
							<>
								<br />
								Border colour: the interaction type of each step.
							</>
						)}
					</span>
				)}
			</span>
			{colours.length > 1 && (
				<div className={styles.map_key_colours} aria-label="Interaction types">
					{colours.map(({ label, color }) => (
						<span key={label} className={styles.map_key_colour}>
							<span className={styles.dot} style={{ width: 8, height: 8, background: color }} />
							{label}
						</span>
					))}
				</div>
			)}
		</div>
	);
};

export default MapKey;
